export default __webpack_public_path__ + "static/media/unnamed (6).6cf0f995.png";